import { themeColor } from "./_helpers";

export const navTokens = {
  activeBg: themeColor({
    base: "{colors.primary.50}",
    _themeBlack: "{colors.whiteAlpha.200}",
    _themeWhite: "{colors.primary.50}",
  }),
  hoverBg: themeColor({
    base: "{colors.neutral.50}",
    _themeBlack: "{colors.whiteAlpha.100}",
    _themeWhite: "{colors.neutral.100}",
  }),
  icon: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.600}",
  }),
  chevron: themeColor({
    base: "{colors.neutral.500}",
    _themeBlack: "{colors.neutral.500}",
    _themeWhite: "{colors.neutral.400}",
  }),
  pinIcon: themeColor({
    base: "{colors.neutral.700}",
    _themeBlack: "{colors.neutral.300}",
    _themeWhite: "{colors.neutral.600}",
  }),
};
